export default "__VITE_ASSET__7af96156__"